module.exports = __webpack_public_path__ + "img/386.0286c84f.jpg";